import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGalleryInner } from "../Service/Api";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";

const monthNames = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec",
];

const Gallery = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(""); // ✅ FIXED
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // ✅ NEW
  const [visibleCount, setVisibleCount] = useState(6);
  const [loading, setLoading] = useState(true);

  const convertDateToDDMMYYYY = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  // ✅ Dynamic years
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = currentYear; i >= 2015; i--) {
      years.push(i.toString());
    }

    setYearRanges(["All", ...years]);
  }, []);

  // ✅ 🔥 Auto fallback year
  useEffect(() => {
    const fetchLatestYear = async () => {
      try {
        const currentYear = new Date().getFullYear();
        let found = [];
        let yearUsed = "";

        for (let y = currentYear; y >= 2015; y--) {
          const res = await getGalleryInner("AFGJI", y.toString());

          if (res && res.length > 0) {
            found = res;
            yearUsed = y.toString();
            break;
          }
        }

        if (!found.length) {
          setData([]);
          setLoading(false);
          return;
        }

        setSelectedYear(yearUsed);

        const formatted = found.map((item) => ({
          ...item,
          formattedDate: item.date
            ? convertDateToDDMMYYYY(item.date)
            : null,
        }));

        setData(formatted);

        const months = new Set();
        formatted.forEach((item) => {
          if (item.date) months.add(new Date(item.date).getMonth());
        });

        const sortedMonths = Array.from(months)
          .sort((a, b) => a - b)
          .map((i) => monthNames[i]);

        setMonthOptions(["All", ...sortedMonths]);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchLatestYear();
  }, []);

  // ✅ Manual year change
  useEffect(() => {
    if (!selectedYear || selectedYear === "All") return;

    const fetchGallery = async () => {
      try {
        setLoading(true);

        const response = await getGalleryInner("AFGJI", selectedYear);

        const formatted = response.map((item) => ({
          ...item,
          formattedDate: item.date
            ? convertDateToDDMMYYYY(item.date)
            : null,
        }));

        setData(formatted);

        const months = new Set();
        formatted.forEach((item) => {
          if (item.date) months.add(new Date(item.date).getMonth());
        });

        const sortedMonths = Array.from(months)
          .sort((a, b) => a - b)
          .map((i) => monthNames[i]);

        setMonthOptions(["All", ...sortedMonths]);
        setSelectedMonth("All");

        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchGallery();
  }, [selectedYear]);

  // ✅ Filtering
  useEffect(() => {
    let filtered = [...data];

    if (selectedMonth !== "All") {
      filtered = filtered.filter((item) => {
        if (!item.date) return false;
        const month = monthNames[new Date(item.date).getMonth()];
        return selectedMonth === month;
      });
    }

    if (searchQuery.trim()) {
      filtered = filtered.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredData(filtered);
  }, [data, selectedMonth, searchQuery]);

  // ✅ Reset Load More
  useEffect(() => {
    setVisibleCount(6);
  }, [selectedYear, selectedMonth, searchQuery]);

  const emptyArray = [
    {
      description: "Stay tuned for the latest updates.",
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Photo Gallery" breadcrumbName="Photo Gallery" />

      <div className="body_height">
        <div className="container">
          <div className="row tabs-dynamic">
            <div className="col-lg-3">
              <p>Total Items: {filterData.length}</p>
            </div>

            {/* Year */}
            <div className="col-lg-3">
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className="yearSelection"
              >
                {yearRanges.map((year, i) => (
                  <option key={i} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {/* Month */}
            <div className="col-lg-3">
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="monthSelect"
              >
                {monthOptions.map((month, idx) => (
                  <option key={idx} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>

            {/* Search */}
            <div className="col-lg-3">
              <input
                type="text"
                placeholder="Search Here..."
                className="form-control"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Gallery */}
          <div className="row mt-3">
            {filterData.length > 0
              ? filterData.slice(0, visibleCount).map((item, index) => (
                  <div
                    className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12 galleryCount"
                    key={index}
                  >
                    <div className="gal_new">
                      <article>
                        <LazyLoad>
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments?.[0]}`}
                            alt={item.title}
                            className="img-fluid"
                            onError={(e) =>
                              (e.target.src = "/default-image.jpg")
                            }
                          />
                        </LazyLoad>

                        <div className="gal-content">
                          <h4 className="catgry-name">{item.title}</h4>
                          <p>{item.description}</p>

                          <h6 className="date">
                            <i className="bi bi-calendar-week"></i>{" "}
                            {item.formattedDate}
                            <span>
                              <a
                                onClick={() =>
                                  navigate(`/SubGallery?id=${item._id}`)
                                }
                              >
                                <i className="bi bi-arrow-right"></i>
                              </a>
                            </span>
                          </h6>

                          <div className="total-img">
                            <i className="bi bi-card-image"></i>
                            <p>{item?.attachments?.length}</p>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                ))
              : emptyArray.map((entry, index) => (
                  <div key={index} className="col-lg-4">
                    <p>{entry.description}</p>
                  </div>
                ))}
          </div>

          {/* ✅ Load More */}
          {visibleCount < filterData.length && (
            <div className="text-center mt-4">
              <button
                className="btn btn-primary"
                onClick={() => setVisibleCount((prev) => prev + 6)}
              >
                Load More ({filterData.length - visibleCount} remaining)
              </button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Gallery;